import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class FilePreviewApi extends ComponentAPI {
}
export default FilePreviewApi;
//# sourceMappingURL=file-preview-api.js.map